import { render, staticRenderFns } from "./CompanyMenuVersionAccess.vue?vue&type=template&id=497535a0&scoped=true"
import script from "./CompanyMenuVersionAccess.vue?vue&type=script&lang=js"
export * from "./CompanyMenuVersionAccess.vue?vue&type=script&lang=js"
import style0 from "./CompanyMenuVersionAccess.vue?vue&type=style&index=0&id=497535a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497535a0",
  null
  
)

export default component.exports